var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1817_1229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0986 18.5291C30.194 18.5291 31.8929 16.8312 31.8929 14.7358C31.8929 12.6405 30.1939 10.9414 28.0986 10.9414C26.0037 10.9414 24.3047 12.6405 24.3047 14.7358C24.3048 16.8312 26.0037 18.5291 28.0986 18.5291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9569 22.186C32.7878 21.17 31.9481 19.7482 31.3124 19.113C31.2287 19.0289 30.8545 19.0094 30.7534 19.072C29.9806 19.5473 29.0729 19.827 28.0986 19.827C27.1254 19.827 26.2176 19.5473 25.4447 19.072C25.3432 19.0094 24.9695 19.0289 24.8858 19.113C24.7081 19.2907 24.5142 19.5273 24.3252 19.8016C24.8366 20.7645 25.2422 21.7874 25.3886 22.6682C25.5349 23.5512 25.4874 24.3872 25.2508 25.1493C26.0911 25.4533 27.0989 25.5867 28.0985 25.5867C30.706 25.5867 33.3744 24.6826 32.9569 22.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4023 16.9297C19.7981 16.9297 22.5513 14.1765 22.5513 10.7807C22.5513 7.38599 19.7981 4.63281 16.4023 4.63281C13.007 4.63281 10.2549 7.38599 10.2549 10.7807C10.2549 14.1765 13.007 16.9297 16.4023 16.9297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.609 17.8704C21.4755 17.7376 20.8696 17.7036 20.7049 17.8056C19.4514 18.5769 17.9804 19.0283 16.4023 19.0283C14.8254 19.0283 13.3537 18.5769 12.1008 17.8056C11.9362 17.7036 11.3302 17.7376 11.1968 17.8704C10.1642 18.902 8.80328 21.208 8.52948 22.8519C7.8544 26.9012 12.1797 28.3632 16.4023 28.3632C20.626 28.3632 24.9513 26.9012 24.2762 22.8519C24.0024 21.208 22.6415 18.902 21.609 17.8704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90184 18.5291C6.9967 18.5291 8.69568 16.8312 8.69568 14.7358C8.69568 12.6405 6.9967 10.9414 4.90184 10.9414C2.80641 10.9414 1.10742 12.6405 1.10742 14.7358C1.10742 16.8312 2.80641 18.5291 4.90184 18.5291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4182 22.6682C7.57379 21.7431 8.01278 20.6538 8.56314 19.6466C8.40975 19.4371 8.25641 19.2546 8.11487 19.113C8.03115 19.0289 7.65745 19.0094 7.55593 19.072C6.78308 19.5473 5.87526 19.827 4.90163 19.827C3.92787 19.827 3.01947 19.5473 2.24725 19.072C2.14619 19.0094 1.77146 19.0289 1.68774 19.113C1.05049 19.7481 0.212919 21.17 0.0432788 22.186C-0.373604 24.6826 2.29424 25.5866 4.90163 25.5866C5.83214 25.5866 6.7718 25.4721 7.57379 25.2102C7.32107 24.4326 7.26757 23.5771 7.4182 22.6682Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1817_1229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvGroup);
export default __webpack_public_path__ + "static/media/EvGroup.8edf2bca6c4867ee0e9e54690a9fa721.svg";
export { ForwardRef as ReactComponent };